import { injectable } from "inversify";
import IRepository from "./IRepository";
import IDataService from "./IDataService";
import PagedDataResultDTO from "features/shared/dtos/PagedDataResultDTO";
import { trackPromise} from 'react-promise-tracker';

@injectable()
export default class DataService implements IDataService {
  async fetchAndSetArray<T>(
    repository: IRepository<T>,
    setData: React.Dispatch<React.SetStateAction<T[]>>,
    url: string,
    routeParams?: URLSearchParams,
    queryParams?: URLSearchParams,
    useTrackPromise?: boolean,
    trackPromiseArea?: string
  ): Promise<void> {

    const fetchAndSetAction = async () => {
      let result = await repository.get({
        url: url,
        routeParams: routeParams,
        params: queryParams
      });
  
      setData(result);
    }

    this.executeFetchAndSetAction(fetchAndSetAction, useTrackPromise, trackPromiseArea);
  }

  async fetchAndSetPagedResult<T>(
    repository: IRepository<T>,
    setData: React.Dispatch<React.SetStateAction<PagedDataResultDTO<T>>>,
    url: string,
    routeParams?: URLSearchParams,
    queryParams?: URLSearchParams,
    useTrackPromise?: boolean,
    trackPromiseArea?: string
  ): Promise<void> {

    const fetchAndSetAction = async () => {
      let result = await repository.getPagedResult({
        url: url,
        routeParams: routeParams,
        params: queryParams
      });
  
      setData(result);
    }

    this.executeFetchAndSetAction(fetchAndSetAction, useTrackPromise, trackPromiseArea);
  }

  async fetchAndSetOne<T>(
    repository: IRepository<T>,
    setData: React.Dispatch<React.SetStateAction<T>>,
    url: string,
    routeParams?: URLSearchParams,
    queryParams?: URLSearchParams,
    useTrackPromise?: boolean,
    trackPromiseArea?: string
  ): Promise<void> {

    const fetchAndSetAction = async () => {
      let result = await repository.getOne({
        url: url,
        routeParams: routeParams,
        params: queryParams
      });
  
      setData(result);
    }
    
    this.executeFetchAndSetAction(fetchAndSetAction, useTrackPromise, trackPromiseArea);
  }

  private executeFetchAndSetAction(executableAction: () => Promise<void>, useTrackPromise?: boolean, trackPromiseArea?: string) {
    if (useTrackPromise) {
      trackPromise(executableAction(), trackPromiseArea);
    } else {
      executableAction();
    }
  }
}